import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as apiReducer } from 'lp-redux-api';
import { applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as modalReducer } from 'redux-modal';
import { reducer as sessionsReducer, enhancer as sessionsEnhancer, } from 'redux-sessions';
import { isNodeEnvProduction, browserHistory, apiMiddlewareLegacy, } from 'shared';
import { abTestsApi } from 'ab-tests-api';
import { affWebhooksApi } from 'aff-webhooks-api';
import { servicingApi } from '../services/api/codegen-outputs/servicingApi';
import { api as consumerPortalApi } from '../services/api/consumerApiSlice';
import { apiMiddlewareRTK, serverErrorLoggingMiddleware, } from '../services/middleware';
import { reducer as rootReducer, reducerKey as rootKey } from './rootReducer';
export function initializeStore(initialState = {}) {
    const enhancers = [
        applyMiddleware(apiMiddlewareLegacy.middleware, apiMiddlewareRTK, serverErrorLoggingMiddleware, routerMiddleware(browserHistory)),
        sessionsEnhancer(),
    ];
    const reducer = {
        api: apiReducer,
        consumerPortalApi: consumerPortalApi.reducer,
        servicingApi: servicingApi.reducer,
        abTestsApi: abTestsApi.reducer,
        affWebhooksApi: affWebhooksApi.reducer,
        form: formReducer,
        modal: modalReducer,
        [rootKey]: rootReducer,
        router: connectRouter(browserHistory),
        sessions: sessionsReducer,
    };
    return configureStore({
        reducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(consumerPortalApi.middleware, abTestsApi.middleware, affWebhooksApi.middleware, servicingApi.middleware),
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(enhancers),
        devTools: isNodeEnvProduction() ? false : true,
        preloadedState: initialState,
    });
}
//extends global window interface to include store and redux dev tools
// moved to js/types
const store = initializeStore();
setupListeners(store.dispatch);
// Add store as global window variable for console debugging
window.store = store;
export default store;
